















import { Vue, Component, Prop } from "vue-property-decorator";
import CardTitle from "../../components/CardTitle.vue";
import RequestsDataTable from "../../components/DataTables/RequestsDataTable.vue";
import * as activity from "../../_store/activity.module";
import * as user from "../../_store/user.module";
import * as auth from "../../_store/auth.module";
import * as data from "../../_store/data.module";
import * as temp from "../../_store/temp.module";
import { Activities } from "../../_models/activities";
import NoActivity from "../../components/Error/NoActivity.vue";
import { bus } from "../../main";
import { userUtils } from "../../_utils/userUtils";
import { router } from "../../_router";

@Component({
  components: {
    CardTitle,
    RequestsDataTable,
    NoActivity
  }
})
export default class TirFormativi extends Vue {
  @Prop() idIstituto!: number;
  @Prop() idAnnoScolastico!: number;
  @Prop() idIscrizioneAttivita!: number;
  private titleParams: object;
  private dataTableParams: any;
  private tirFormativiStatus: boolean;
  private createParams: object;

  constructor() {
    super();
    this.titleParams = {
      title: "TIROCINI FORMATIVI",
      cols: "10",
      sm: "5",
      md: "5",
      lg: "4"
    };
    this.tirFormativiStatus = false;
    this.dataTableParams = {
      headers: [
        {
          text: "Settore",
          value: "nomeSettore"
        },
        {
          text: "Indirizzo Studio",
          value: "nomeIndirizzoStudio"
        },
        {
          text: "Nome Tirocinante Indicato",
          value: "nomeTirocinante"
        },
        {
          text: "Cognome Tirocinante Indicato",
          value: "cognomeTirocinante"
        },
        {
          text: "Classe Tirocinante Indicato",
          value: "classeTirocinante"
        },
        {
          text: "",
          value: "actionEnterprise",
          sortable: false
        }
        // {
        //   text: "",
        //   value: "delete",
        //   sortable: false
        // },
        // {
        //   text: "",
        //   value: "edit",
        //   sortable: false
        // }
      ],
      records: [],
      dialogParams: {
        title: "DETTAGLI TIROCINIO FORMATIVO",
        type: "richiestaTirFormativoTab"
      },
      type: "tirociniFormativi"
    };
    this.createParams = {
      visible: true,
      type: "nuovaRichiestaTirocinanteFormativo",
      idIstituto: this.idIstituto,
      idAnnoScolastico: this.idAnnoScolastico,
      idIscrizioneAttivita: this.idIscrizioneAttivita
    };
  }

  // checkStatus(activities: Activities[]): boolean {
  //   var flag: boolean = false;
  //   activities.forEach(element => {
  //     if (element.tirocinioFormativo === true) {
  //       flag = true;
  //     }
  //   });
  //   return flag;
  // }
  created() {
    if (
      this.idIscrizioneAttivita !== null &&
      this.idIscrizioneAttivita !== undefined
    ) {
      var token = localStorage.getItem("userToken");
      var parsedToken: any;
      this.tirFormativiStatus = true
      if (token !== null) {
        parsedToken = userUtils.parseToken(token);
      }
      var payload = {
        idUtente: parsedToken.IdUtente,
        tipoSoggetto: parsedToken.IdTipoSoggetto,
        username: parsedToken.Username
      };
      user
        .dispatchSetUserInfo(this["$store"], payload)
        .then(() => {
          user
            .dispatchSetEnterpriseInfo(this["$store"])
            .then(() => {
              bus.$emit("loadMenu");
              var enterpriseInfo = user.readEnterpriseInfo(this["$store"]);
              data
                .dispatchRichiesteTirFormativi(
                  this["$store"],
                  this.idIscrizioneAttivita
                )
                .then(response => {
                  this.dataTableParams.records = response;
                  bus.$emit("dataLoaded");
                })
                .catch(error => {
                  if (error.response.status === 403) {
                    bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                    this["$router"].push("/login");
                  } else {
                    bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                  }
                });
            })
            .catch(() => {
              bus.$emit("stopLoading");
              auth.dispatchLogout(this["$store"]);
              user.dispatchClearState(this["$store"]);
              this["$router"].push("/sessionExpired");
            });
        })
        .catch(() => {
          bus.$emit("stopLoading");
          auth.dispatchLogout(this["$store"]);
          user.dispatchClearState(this["$store"]);
          this["$router"].push("/sessionExpired");
        });
    } else {
      router.push({
        name: "iscrizioneTirFormativi",
        params: {}
      });
    }

    bus.$on("refreshTirFormativiTable", () => {
      data
        .dispatchRichiesteTirFormativi(
          this["$store"],
          this.idIscrizioneAttivita
        )
        .then(response => {
          this.dataTableParams.records = response;
          bus.$emit("dataLoaded");
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          }
        });
    });
  }
}
